module.exports = __webpack_public_path__ + "media/images/icon-settings-e4c1fb61378e9a9ee35fdccffe6fa39e.png";